import Reflux from 'reflux';

let CuesheetToolbarActions = Reflux.createActions({
  toggleBold: {},
  toggleItalic: {},
});

export default CuesheetToolbarActions;
